import { render } from "./TicketPayoutPage.vue?vue&type=template&id=cade031a&ts=true"
import script from "./TicketPayoutPage.vue?vue&type=script&lang=ts"
export * from "./TicketPayoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__